import React from 'react'
import {Box, CssBaseline, Link, Typography} from '@material-ui/core'
import {makeStyles} from '@material-ui/core/styles'
import Footer from '../components/Footer'
import LoginForm from './Login/LoginForm'

// IMAGES
import loginFormImg from '../images/login-form-img.svg'
import divingEagle from '../images/diving-eagle.svg'
import logoImg from '../images/unt-lettermark.svg'

// using hook API
const useStyles = makeStyles(theme => ({
    root: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
    },
    leftPanel: {
        paddingTop: '2.85rem',
        paddingLeft: '2.85rem',
        backgroundColor: theme.palette.primary.main,
        backgroundSize: '80%',
        backgroundImage: `url(${divingEagle})`,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'bottom left',
        width: '43%',
        height: '100vh',
        [theme.breakpoints.down('md')]: {
            display: 'none',
        },
    },
    rightPanel: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        width: '57%',
        [theme.breakpoints.down('md')]: {
            width: '80%',
        },
    },
    rightPanelContent: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        minHeight: 'calc(90vh -  32px)',
        maxWidth: '50%',
        [theme.breakpoints.down('sm')]: {
            maxWidth: '90%',
        },
    },
    untLogo: {
        width: '40%',
        [theme.breakpoints.up('md')]: {
            maxWidth: '350px',
        },
    },
    signInImage: {
        marginTop: '5%',
        marginBottom: '5%',
        [theme.breakpoints.down('md')]: {
            marginTop: '2%',
            marginBottom: '2%',
        },
    },
}))

const Login = () => {
    const classes = useStyles()

    return (
        <>
            <CssBaseline />
            <Box className={classes.root}>
                <Box className={classes.leftPanel}>
                    <img
                        src={logoImg}
                        className={classes.untLogo}
                        alt="UNT Lettermark"
                    />
                </Box>
                <Box className={classes.rightPanel}>
                    <Box className={classes.rightPanelContent}>
                        <Box>
                            <img
                                src={loginFormImg}
                                alt="Login Form"
                                className={classes.signInImage}
                            />
                            <Typography
                                variant="h4"
                                align="left"
                                style={{color: '#098447'}}
                            >
                                Sign in
                            </Typography>
                        </Box>
                        <LoginForm />
                        <Typography variant="body1" align="center">
                            Forgot your&nbsp;
                            <Link
                                href="https://ams.unt.edu/"
                                target="_blank"
                                rel="noreferrer noopener"
                            >
                                EUID or password
                            </Link>
                            ?
                        </Typography>
                    </Box>
                    <Footer />
                </Box>
            </Box>
        </>
    )
}

export default Login
